import WindowResolver from './WindowResolver'


interface IGlobalNewRelic {
  interaction(): object
  addPageAction(): void
  addRelease(): void
  addToTrace(): void
  finished(): void
  inlineHit(): void
  noticeError(): void
  setCurrentRouteName(): void
  setCustomAttribute(): void
  setErrorHandler(): void
  setPageViewName(): void
  setToken(): void
  info: {
    beacon: string
    errorBeacon: string
    licenseKey: string
    applicationID: string,
    a: number
  }
}

declare global {
  interface Window {
    newrelic: IGlobalNewRelic
  }
}

const windowEntity = 'newrelic'

const methods = {
  interaction: true,
}

interface INewRelic {
  interaction(): object
  addPageAction(): void
  addRelease(): void
  addToTrace(): void
  finished(): void
  inlineHit(): void
  noticeError(): void
  setCurrentRouteName(): void
  setCustomAttribute(): void
  setErrorHandler(): void
  setPageViewName(): void
  setToken(): void
}

const newrelic = new WindowResolver({
  name: windowEntity,
  methods,
  logToConsole: false,
  resolver: () => Boolean(window.newrelic),
  eventHandler: (methodName, ...args) => {
    window.newrelic[methodName](...args)
  },
}) as unknown as INewRelic


export {
  windowEntity,
  methods,
}

export default newrelic
